import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer'
import { TEETH, getTpJaw, jawTypes, mergeJawTypes, formatKeyframe } from 'Ui/Components/specsMobileUtils'

const SPE = {
    att: ['attachmentPos', 'attachmentNeg', 'button'],
    ipr: ['mesial', 'distal']
}

export const IprAttMobile = props => {

    const
        {
            att,
            ipr,
            getJawType,
            jaw,
            setJaw,
            getNumeric,
            getTpJaw,
            teeth,
            spe
        } = props,
        toothMatrix = [
            {
                teeth: teeth[jaw].ant,
                title: ihm_viewer__dictionary.ANT_SECTOR[locale()],
            },
            {
                teeth: teeth[jaw].post,
                title: ihm_viewer__dictionary.POST_SECTOR[locale()],
            }
        ]


    const labels = i =>
        <div className="labels" key={'label-cont-' + i}>
            {spe.ipr.map((special, ii) =>
                ipr.length > 0 ?
                    <div
                        className="labelItem"
                        key={`label-${special}-${i}-${ii}`}
                    >
                        {ihm_viewer__dictionary.SPE_IPR_ATT_ITEM[special.toUpperCase()][locale()]}
                    </div> :
                    null
            )}
            <br/>
            {spe.att.map((special, ii) =>
                att.length > 0 ?
                    <div
                        className="labelItem"
                        key={`label-${special}-${i}-${ii}`}
                    >
                        { ihm_viewer__dictionary.SPE_IPR_ATT_ITEM[special.toUpperCase()][locale()] }
                    </div> :
                    null
            )}
        </div>


    return (
        <section className="specsMobile">
            <header>
                <h3>
                    {ihm_viewer__dictionary['SPE_IPR_ATT'][locale()]}
                    <br/>
                    <span>{ihm_viewer__dictionary['SPE_TOTAL'][locale()]}</span>
                </h3>
                <div className="SpecificationMember">
                    {getJawType({ ipr, att }).map( jawId =>
                        <div
                            className={(jaw === getTpJaw(jawId).name) ? "selected" : null}
                            onClick={() => setJaw(getTpJaw(jawId).name)}
                            key={jawId}
                        >
                            {ihm_viewer__dictionary[getTpJaw(jawId).TRANS][locale()]}
                        </div>
                    )}
                </div>
            </header>

            <div className="flexContainer">
                {toothMatrix.map((el, i) =>
                    <div className="flexItem" key={'table-' + el.title + i}>
                        <h4>{el.title}</h4>
                        <div className="containerSpec">
                            {labels(i)}
                            <div className="containerTable">
                                <table>

                                    <thead>
                                        <tr>
                                            {el.teeth.map((el, teethIndex) =>
                                                [
                                                    teethIndex > 0 ? <th className="separator" key={'th-sep-' + teethIndex}/> : null,
                                                    el.map((item, iii) => <th key={'th-' + item}>{item}</th>)
                                                ]
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {spe.ipr.map(special =>
                                        ipr.length > 0 ?
                                            <tr className='ipr' key={'ipr'+special+'line'}>
                                                {el.teeth.map((el, teethIndex) =>
                                                    [
                                                        teethIndex > 0 ? <td className="separator" key={'td-sep-' + teethIndex}/> : null,
                                                        el.map((tooth, indexValue) =>
                                                            <td key={'ipr-' + tooth + indexValue}>
                                                                { getNumeric('TOTAL', special, tooth, 'ipr' ) }
                                                            </td>
                                                        )
                                                    ]
                                                )}
                                            </tr> :
                                            null
                                    )}

                                    {att.length > 0 ?
                                        <tr className='line-separator' key="line-separator">
                                          {el.teeth.map((el, teethIndex) =>
                                              [
                                                  teethIndex > 0 ? <td key={'td-sep-' + teethIndex} className="separator"/> : null,
                                                  el.map(tooth => <td key={'ipr-' + tooth}/>)
                                              ]
                                          )}
                                        </tr> : null
                                    }

                                    {spe.att.map((special, i) =>
                                        att.length > 0 ?
                                            <tr className='att' key={'att'+special+'line'}>
                                                {el.teeth.map((el, teethIndex) =>
                                                    [
                                                        teethIndex > 0 ? <td key={'td-sep-' + teethIndex} className="separator"/> : null,
                                                        el.map(tooth =>
                                                            <td key={'att-' + special + tooth} className="token">
                                                                {(getNumeric('TOTAL', special, tooth, 'attachments')) ? <span className={'token token'+i}>&nbsp;</span> : null}
                                                            </td>
                                                        )
                                                    ]
                                                )}
                                            </tr>:
                                        null
                                    )}
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </section>
    )
}

export const MobileIprAttSection = () => {
    const { AnimationReducer } = useSelector(s => s)
    const treatment = AnimationReducer.metas?.treatment

    const attContent = treatment?.attachment
    const iprContent = treatment?.ipr
    const att = attContent && attContent !== 'none' ? jawTypes(attContent) : []
    const ipr = iprContent && iprContent !== 'none' ? jawTypes(iprContent) : []

    const mergedJaws = mergeJawTypes(att, ipr)
    const initialJaw = mergedJaws.includes('upper') ? 'tpUpper' : 'tpLower'
    const [jaw, setJaw] = useState(initialJaw)

    if (att.length === 0 && ipr.length === 0) return null

    const keyframe = formatKeyframe(AnimationReducer.keyframe)

    const getJawType = () => mergedJaws

    const getNumeric = (sect, special, tooth, type) => {
        const sector = sect !== 'TOTAL' ? 'step_' + keyframe : 'totalAmount'
        const container = AnimationReducer.metas.treatmentPlanning?.[jaw]?.[sector]
        if (!container?.['toothID_' + tooth]?.[type]?.[special]) return false
        const nb = Number.parseFloat(container['toothID_' + tooth][type][special]).toFixed(2)
        return nb !== '0.0' && nb !== '-0.0' ? nb : false
    }

    return (
        <IprAttMobile
            att={att}
            ipr={ipr}
            getJawType={getJawType}
            jaw={jaw}
            setJaw={setJaw}
            getNumeric={getNumeric}
            getTpJaw={getTpJaw}
            teeth={TEETH}
            spe={SPE}
        />
    )
}
